import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ComparisonSection() {
  return <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-61">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-62">
        <div className="text-center mb-16" data-id="element-63">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-64">
            Why Caveo Instead of Another Security App?
          </h2>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-65">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-66">
            {/* The Others */}
            <div className="bg-white rounded-2xl p-8 border-2 border-gray-300" data-id="element-67">
              <div className="text-center mb-6" data-id="element-68">
                <span className="inline-block bg-gray-200 text-gray-600 px-4 py-2 rounded-lg font-bold text-sm uppercase tracking-wide" data-id="element-69">
                  Typical Security Apps
                </span>
              </div>
              <div className="space-y-4" data-id="element-70">
                <div className="flex items-center" data-id="element-71">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-72">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-73" />
                  </div>
                  <span className="text-gray-600" data-id="element-74">
                    Scare you into buying more
                  </span>
                </div>
                <div className="flex items-center" data-id="element-75">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-76">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-77" />
                  </div>
                  <span className="text-gray-600" data-id="element-78">
                    Drown you in tech jargon
                  </span>
                </div>
                <div className="flex items-center" data-id="element-79">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-80">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-81" />
                  </div>
                  <span className="text-gray-600" data-id="element-82">
                    Monitor you without teaching you
                  </span>
                </div>
                <div className="flex items-center" data-id="element-83">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-84">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-85" />
                  </div>
                  <span className="text-gray-600" data-id="element-86">
                    Leave you dependent on their tools
                  </span>
                </div>
              </div>
            </div>

            {/* Caveo */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#631bb7]" data-id="element-87">
              <div className="text-center mb-6" data-id="element-88">
                <span className="inline-block bg-[#631bb7] text-white px-4 py-2 rounded-lg font-bold text-sm uppercase tracking-wide" data-id="element-89">
                  Caveo
                </span>
              </div>
              <div className="space-y-4" data-id="element-90">
                <div className="flex items-center" data-id="element-91">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-92">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-93" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-94">
                    Gives you honest, no-upsell guidance
                  </span>
                </div>
                <div className="flex items-center" data-id="element-95">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-96">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-97" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-98">
                    Explains everything in plain English
                  </span>
                </div>
                <div className="flex items-center" data-id="element-99">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-100">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-101" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-102">
                    Teaches your whole family to stay safe
                  </span>
                </div>
                <div className="flex items-center" data-id="element-103">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-104">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-105" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-106">
                    Builds real confidence that lasts
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center" data-id="element-107">
            <Link to="/intro-assessment" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-108">
              Start Now
            </Link>
          </div>
        </div>
      </div>
    </section>;
}